interface ItemAvatar {
    name: string;
    base64: string;
}

class Base64Warehouse {
    elements: ItemAvatar[] = [
    ];

    public getAvatar(name: string) {
        var item = this.elements.find((x) => x.name == name);
        return item ? item.base64 : null;
    }
}

export const base64Warehouse = new Base64Warehouse();